import {
    SPONSOR_LOAD_START,
    SPONSOR_LOAD_ERROR,
    SPONSOR_LOAD_COMPLETE,
} from '../actions/sponsor';

const initialState = {
    sponsor: null,
    error: null,
};

export default function sponsorReducer(state = initialState, action) {
    switch (action.type) {
        case SPONSOR_LOAD_START:
            return {sponsor: null, error: null};
        case SPONSOR_LOAD_COMPLETE:
            return {sponsor: action.sponsor, error: null};
        case SPONSOR_LOAD_ERROR:
            return {sponsor: null, error: action.error};
        default:
            return state;
    }
}
